import React, { useState } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// images
import img1 from "../../../assets/images/images-1.jpg";
import img2 from "../../../assets/images/images-2.jpg";
import img3 from "../../../assets/images/images-3.jpg";
import img4 from "../../../assets/images/images-4.jpg";
import img5 from "../../../assets/images/images-5.jpg";
import img6 from "../../../assets/images/images-6.jpg";
import img7 from "../../../assets/images/images-7.jpg";

const CarouselPage = () => {
  const navigationStyles = {
    color: "#fff",
  };

  const [scaleValue, setScaleValue] = useState(0.2);

  const handleSlideChange = (swiper : any) => {
    setScaleValue((prevScale) => {
      const newScale = prevScale + 0.2;
      return newScale > 1 ? 0.2 : newScale; // Reset to 0.2 when it reaches 1
    });
    swiper.update(); 
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Carousel" pageType="Components" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {/* Basic */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Carousel
            </h2>
            <Swiper
              className="swiper SwiperDefault"
              dir="ltr"
              slidesPerView={1}
              autoplay={{ delay: 3000 }}
            >
              <SwiperSlide>
                <img
                  src={img1}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img2}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img3}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img4}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img5}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
            </Swiper>
          </div>

          {/* Basic Carousel With Arrow */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Carousel With Arrow
            </h2>
            <Swiper
              className="swiper SwiperwithArrows"
              dir="ltr"
              slidesPerView={1}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              modules={[Navigation]}
            >
              <SwiperSlide>
                <img
                  src={img6}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img7}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img2}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img4}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img5}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <div
                className="swiper-button-next text-white"
                style={navigationStyles}
              ></div>
              <div
                className="swiper-button-prev text-white"
                style={navigationStyles}
              ></div>
            </Swiper>
          </div>

          {/* Basic Carousel With Pagination */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Carousel With pagination
            </h2>
            <Swiper
              className="swiper SwiperwithArrows"
              dir="ltr"
              slidesPerView={1}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
            >
              <SwiperSlide>
                <img
                  src={img5}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img4}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img2}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img6}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img7}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
            </Swiper>
          </div>
          {/* Basic Carousel With Progress */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Carousel With Progress
            </h2>
            <Swiper
              className="swiper SwiperwithProgress"
              dir="ltr"
              slidesPerView={1}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              modules={[Navigation, Pagination]}
              pagination={{
                clickable: true,
              }}
              on={{
                slideChange: (swiper : any) => handleSlideChange(swiper),
              }}
            >
              <div className="swiper-pagination swiper-pagination-progressbar swiper-pagination-horizontal">
                <span
                  className="swiper-pagination-progressbar-fill"
                  style={{
                    transform:
                      `translate3d(0px, 0px, 0px) scaleX(${scaleValue}) scaleY(1)`,
                    transitionDuration: "300ms",
                  }}
                ></span>
              </div>
              <SwiperSlide>
                <img
                  src={img4}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img3}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img2}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img6}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img7}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
            <div
              className="swiper-button-next text-white"
              style={navigationStyles}
            ></div>
            <div
              className="swiper-button-prev text-white"
              style={navigationStyles}
            ></div>
            </Swiper>
            <div className="swiper-pagination"></div>
          </div>
          {/* Basic Carousel With Multiple Slides */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Carousel With Multiple Slides
            </h2>
            <Swiper
              className="swiper SwiperMultiple"
              dir="ltr"
              slidesPerView={2}
              spaceBetween={30}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
            >
              <SwiperSlide>
                <img
                  src={img7}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img6}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img2}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img4}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={img3}
                  alt="slider"
                  className="object-cover w-full max-h-96"
                />
              </SwiperSlide>
            </Swiper>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CarouselPage;
